
import { computed, defineAsyncComponent, defineComponent, PropType, toRefs } from 'vue';

import { useFileUpload } from '@/hooks/use_file_upload';
import { ContentBase } from '@/models/content_base';
import { ContentTextEditorModel } from '@/models/content_text_editor_model';
import { Style } from '@/models/style';

import BaseIcon from './BaseIcon.vue';
import BaseStyle from './BaseStyle.vue';
import ContentTextEditor from './ContentTextEditor.vue';

export default defineComponent({
  name: 'ContentCustomizingUploadedText',
  components: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Content: defineAsyncComponent((): any => import('./Content.vue')),
    BaseIcon,
    BaseStyle,
    ContentTextEditor,
  },
  props: {

    /**
     * コンテンツ
     */
    contents: {
      type: Array as PropType<ContentBase[]>,
      required: true,
    },
  },
  setup(props) {
    const { contents } = toRefs(props);
    const fileUpload = useFileUpload();
    const checkboxSize = 20;

    function toContentModel<T extends ContentBase>() {
      const model = contents.value[1] as T;
      return model;
    }
    return {
      fileUpload,
      contentTextEditor: computed<ContentTextEditorModel>(toContentModel),
      checkboxSize,
      Style,
    };
  },
});
